<template>
	<div class="form-section-base__controls">
		<v-row>
			<v-col>
				<v-radio-group @change="changeRole" row :value="value">
					<v-radio
						label="Физическое лицо"
						:value="Role.PERSON"
						:disabled="roleType !== Role.PERSON || isSurcharge"
					/>
					<v-radio
						label="Юридическое лицо"
						:value="Role.ORGANIZATION"
						:disabled="isOrganizationDisabled"
					/>
					<v-radio
						label="Иностранное юридическое лицо"
						:value="Role.FOREIGN_ORGANIZATION"
						:disabled="isForeignOrganizationDisabled"
					/>
				</v-radio-group>
			</v-col>
		</v-row>
	</div>
</template>
<script>
import {Role} from "@/utils/dictionaries";

export default {
	name: 'RoleSelector',
	computed: {
	},
	props: {
		isForeignOrganizationDisabled: {},
		isOrganizationDisabled: {},
		isSurcharge: {},
		value: {},
		roleType: {}
	},
	data() {
		return {
			Role
		}
	},
	methods: {
		changeRole(value) {
			this.$emit('input', value)
		}
	}
}
</script>
